import React from "react";
import "./TooltipCustom.css";

const TooltipCustom = ({ children, firstText, secondText, disabled = false }) => {
  if (!disabled) {
    return children;
  }

  return (
    <span
      className="tooltip-custom-wrapper"
      onMouseEnter={(e) => {
        const tooltip = e.currentTarget.querySelector('.tooltip-custom-content');
        const rect = e.currentTarget.getBoundingClientRect();
        tooltip.style.left = `${rect.right}px`;
        tooltip.style.top = `${rect.top + rect.height / 2 - tooltip.offsetHeight / 2}px`;
      }}
    >
      {children}
      <span className="tooltip-custom-content">
        <div>{firstText || 'Recurso disponível nos'}</div>
        <div>{secondText || 'planos Galaxy e Infinity'}</div>
      </span>
    </span>
  );
};

export default TooltipCustom;

